import { render } from "./RegisterModal.vue?vue&type=template&id=5261c83c&scoped=true"
import script from "./RegisterModal.vue?vue&type=script&lang=js"
export * from "./RegisterModal.vue?vue&type=script&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=5261c83c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5261c83c"]])

export default __exports__